let pendingFile: File | null = null;

export const uploadStore = {
  set(file: File | null): void {
    pendingFile = file;
  },
  get(): File | null {
    return pendingFile;
  },
  clear(): void {
    pendingFile = null;
  },
};
